// extracted by mini-css-extract-plugin
export var animateCircle = "one-service-technology-map-module--animate-circle--cHepD";
export var bounce = "one-service-technology-map-module--bounce--CGDb2";
export var container = "one-service-technology-map-module--container--9LruU";
export var content = "one-service-technology-map-module--content--QI1yA";
export var description = "one-service-technology-map-module--description--WijLC";
export var ldsRing = "one-service-technology-map-module--lds-ring--EJYmZ";
export var row = "one-service-technology-map-module--row--8wJrs";
export var title = "one-service-technology-map-module--title--GeJud";